import React, { FunctionComponent, useCallback } from 'react';
import Input from 'react-phone-number-input/input';
import Styles from './Styles.module.scss';

type Props = {
    label: string;
    placeholder?: string;
    value: string | undefined;
    onChange: (value: string) => void;
    isValid: boolean;
    onBlur?: () => void;
};

export const PhoneInputBox: FunctionComponent<Props> = ({
    label,
    placeholder,
    value,
    onChange,
    isValid,
    onBlur,
}) => {
    const changeHandler = useCallback(
        (newValue: string | undefined) => {
            onChange(newValue as string);
        },
        [onChange]
    );

    return (
        <div className={`form-control-box w-100`}>
            <label
                htmlFor="first_name"
                className={`${Styles.Label} ${!isValid && Styles.InvalidLabel}`}
            >
                {label}
            </label>

            <div className={`${Styles.InputContainer}`}>
                <Input
                    country="US"
                    className={`w-100  ${!isValid && Styles.InputInvalid}`}
                    placeholder={placeholder}
                    onChange={changeHandler}
                    onBlur={onBlur}
                    value={value}
                />
            </div>
        </div>
    );
};
